import React from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Translate, ThankYouComponent } from '../../../Share/components';
import './style.scss';

const propTypes = {
  assignment: PropTypes.shape({}),
  location: PropTypes.shape({
    state: PropTypes.shape({
      assignmentDetail: PropTypes.shape({}),
    }),
  }),
};

const defaultProps = {
  assignment: {},
  location: {
    state: {
      assignmentDetail: null,
    },
  },
};

function SubmittedCancel({ location }) {
  const assignmentDetail = location.state ? location.state.assignmentDetail : null;
  if (!assignmentDetail) {
    return (
      <Navigate to="/my-assignment" replace />
    );
  }
  return (
    <ThankYouComponent
      callbackUrl="/"
      buttonText={Translate({ content: 'submittedCancel.backToDashboard' })}
    >
      <div className="tv-submittedcancel__title">
        <Translate content="submittedCancel.youCancelledFor" />
      </div>
      <div className="tv-submittedcancel__data">
        <div className="tv-submittedcancel__number">{assignmentDetail.OrderNumber}</div>
        {/* <div className="tv-submittedcancel__content">{assignmentDetail.Category}</div> */}
      </div>
    </ThankYouComponent>
  );
}

SubmittedCancel.propTypes = propTypes;
SubmittedCancel.defaultProps = defaultProps;

export default SubmittedCancel;
